import { INDIVIDUAL_SEMI_ANNUAL_PRICE_RANGES } from '../constants/stripe-constants';
function isSemiAnnual(subscription) {
    var _a;
    try {
        for (const item of subscription.items.data) {
            // console.log('lookup_key:', item?.price?.lookup_key);
            // console.log(isSemiAnnualLookupKey(item?.price?.lookup_key), isSemiAnnualLookupKey('SEMI_ANNUAL_MIDDLE_SCHOOL_6-8'));
            const hasOne = isSemiAnnualLookupKey((_a = item === null || item === void 0 ? void 0 : item.price) === null || _a === void 0 ? void 0 : _a.lookup_key);
            if (hasOne)
                return 'yes';
        }
        return 'no';
    }
    catch (error) {
        console.error(error);
    }
    return 'error';
}
function isSemiAnnualLookupKey(lookupKey) {
    const values = Object.values(INDIVIDUAL_SEMI_ANNUAL_PRICE_RANGES);
    return values.some(value => value.lookup_key === lookupKey);
}
export { isSemiAnnual };
